import React from 'react'
import classNames from 'classnames'
import { Chip } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

const CustomChip = ({ className, disabled, selected, onButtonClick, onClick, ...props }) => {
  return (
    <Chip
      className={classNames('custom-chip', { 'custom-chip--disabled': disabled }, className, {
        'opacity-50': disabled,
      })}
      selected={!!disabled && selected}
      onButtonClick={!disabled && onButtonClick}
      onClick={(!disabled && onClick) || (() => {})}
      {...props}
    />
  )
}

export default CustomChip
